import {Logger} from './logger';

export type {DatadogUser} from './datadog-logger';
export {DatadogLogger, initDatadog, isDatadogEnabled, setDatadogUser} from './datadog-logger';
export {ConsoleLogger} from './console-logger';
export {LoggerManager} from './logger-manager';
export default Logger;
